<div class="container">
    <!-- Tabs Navigation -->
    <div class="tabs-container">
        <div class="tab-buttons">
            <button
                    [class.active]="selectedTab == Tab.Generate"
                    (click)=selectTab(Tab.Generate)>
                Generate
            </button>
            <button
                    [class.active]="selectedTab == Tab.Reports"
                    (click)=selectTab(Tab.Reports)>
                Reports
            </button>

            <button
                    [class.active]="selectedTab == Tab.LookUp"
                    (click)=selectTab(Tab.LookUp)>
                Look up
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">

            <!-- Generate Tab -->
            <div *ngIf="selectedTab == Tab.Generate" class="section generate">
                <generate/>
            </div>

            <!-- Reports Tab -->
            <div *ngIf="selectedTab == Tab.Reports" class="section reports">
                <report/>
            </div>

            <!-- LookUp Tab -->
            <div *ngIf="selectedTab == Tab.LookUp" class="section lookUp">
                <look-up/>
            </div>
        </div>
    </div>
</div>